import React from "react";
import styles from "./StepIndicator.module.scss";

interface StepIndicatorProps {
	total: number;
	current: number;
	onStepClick?: (index: number) => void;
	onlyPrevious?: boolean;
}

const StepIndicator = ({ total, current, onStepClick, onlyPrevious = false }: StepIndicatorProps) => {
	return (
		<div className={styles.indicators}>
			{Array.from({ length: total }).map((_, index) => {
				const isPrevious = index < current;
				const isActive = index === current;
				const isClickable = onlyPrevious ? isPrevious : index !== current;
				return (
					<button
						key={index}
						className={`${styles.dot} ${isActive ? styles.activeDot : ""} ${isPrevious ? styles.completedDot : ""}`}
						onClick={() => isClickable && onStepClick?.(index)}
						disabled={!isClickable}
						aria-label={`Go to step ${index + 1}`}
					/>
				);
			})}
		</div>
	);
};

export default StepIndicator;
